import { parseMonthToValue } from './dataUtils'

export const TMB_LAUNCH_DATE: Record<string, number> = {
    '001': 20270401, '002': 20260427, '003': 20260406, '007': 20270401,
    '010': 20261005, '011': 20261005, '013': 20270401, '015': 20261005,
    '016': 20260406, '022': 20260406, '034': 20260706, '036': 20260406,
    '040': 20270401, '046': 20260629, '051': 20261005, '055': 20260406,
    '058': 20270401, '066': 20261005, '090': 20261005, '096': 20261005,
    '099': 20261005, '110': 20270401, '112': 20270401,
}

const normalizeHospitalId = (id: any): string => String(id ?? '').trim().padStart(3, '0')

const launchMonthOf = (launch: number): number => Math.floor(launch / 100)

export const parseSurveyDateToNum = (raw: any): number | null => {
    if (!raw) return null
    const m = String(raw).trim().match(/^(\d{1,2})[.\/-](\d{1,2})[.\/-](\d{4})$/)
    if (!m) return null
    const day = parseInt(m[1], 10)
    const month = parseInt(m[2], 10)
    const year = parseInt(m[3], 10)
    if (month < 1 || month > 12 || day < 1 || day > 31) return null
    return year * 10000 + month * 100 + day
}

export function filterRowsByLaunchDate(
    rows: any[],
    hospitalIdIdx: number,
    surveyDateIdx: number,
): any[] {
    if (!Array.isArray(rows) || hospitalIdIdx < 0 || surveyDateIdx < 0) return rows
    return rows.filter((r) => {
        const launch = TMB_LAUNCH_DATE[normalizeHospitalId(r[hospitalIdIdx])]
        if (launch == null) return true
        const d = parseSurveyDateToNum(r[surveyDateIdx])
        if (d == null) return true
        return d >= launch
    })
}

export function filterRowsByLaunchMonth(
    rows: any[],
    hospitalIdIdx: number,
    monthIdx: number,
): any[] {
    if (!Array.isArray(rows) || hospitalIdIdx < 0 || monthIdx < 0) return rows
    return rows.filter((r) => {
        const launch = TMB_LAUNCH_DATE[normalizeHospitalId(r[hospitalIdIdx])]
        if (launch == null) return true
        const mv = parseMonthToValue(r[monthIdx])
        if (!mv) return true
        return mv >= launchMonthOf(launch)
    })
}

export const isDatePostLaunch = (hospitalId: any, surveyDateRaw: any): boolean => {
    const launch = TMB_LAUNCH_DATE[normalizeHospitalId(hospitalId)]
    if (launch == null) return true
    const d = parseSurveyDateToNum(surveyDateRaw)
    if (d == null) return true
    return d >= launch
}

export const isMonthPostLaunch = (hospitalId: any, monthRaw: any): boolean => {
    const launch = TMB_LAUNCH_DATE[normalizeHospitalId(hospitalId)]
    if (launch == null) return true
    const mv = parseMonthToValue(monthRaw)
    if (!mv) return true
    return mv >= launchMonthOf(launch)
}

const findColIdx = (columns: any[], names: string[]): number =>
    columns.findIndex((c: any) => names.includes(String(c).trim().toLowerCase()))

export function applyLaunchDateFilterToZohoData(data: any): any {
    const result = data?.response?.result
    if (!Array.isArray(result?.rows) || !Array.isArray(result?.column_order)) return data
    const hIdx = findColIdx(result.column_order, ['hospital_id', 'hospitalid'])
    const dIdx = findColIdx(result.column_order, ['survey_date'])
    result.rows = filterRowsByLaunchDate(result.rows, hIdx, dIdx)
    return data
}

export function applyLaunchMonthFilterToZohoData(data: any): any {
    const result = data?.response?.result
    if (!Array.isArray(result?.rows) || !Array.isArray(result?.column_order)) return data
    const hIdx = findColIdx(result.column_order, ['hospital_id', 'hospitalid'])
    const mIdx = findColIdx(result.column_order, ['survey_month', 'month', 'time_period'])
    result.rows = filterRowsByLaunchMonth(result.rows, hIdx, mIdx)
    return data
}
